
<template>
  <Loader v-if="loader" />

  <div v-if="hasSearched">
    <div class="card riepilogo-provvigioni" v-for="(item, year) in items" :key="year">

      <div class="simplified-header">
        <div class="simplified-title">Margini</div>
        <div class="simplified-subtitle">{{year}}</div>
        <div class="simplified-entity">{{rappresentanteName}}</div>
      </div>

      <div class="simplified-table-container">
        <table class="simplified-table-custom">
          <thead>
            <tr>
              <th class="col-mese">Mese Competenza</th>
              <th class="col-margine text-right">Margine pagato</th>
              <th class="col-margine text-right">Margine atteso</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="data in item" :key="data.mese_fatturazione">
              <td class="col-mese">{{getMonthFormat(data.mese_fatturazione)}}</td>
              <td class="col-margine text-right">{{formatCurrency(data.totale_pcv_pod + data.totale_pcv_pdr + data.totale_ricorsivo_pod + data.totale_ricorsivo_pdr)}}</td>
              <td class="col-margine text-right">{{formatCurrency(data.totale_pcv_pod_fatturato + data.totale_pcv_pdr_fatturato + data.totale_ricorsivo_pod_fatturato + data.totale_ricorsivo_pdr_fatturato)}}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td class="col-mese">Totali</td>
              <td class="col-margine text-right">{{totale_euro(year)}}</td>
              <td class="col-margine text-right">{{totale_fatturato_euro(year)}}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>

  <div class="card riepilogo-provvigioni" v-if="hasSearched && Object.keys(items).length === 0 && !loader">
    <div class="simplified-header">
      <div class="simplified-title">Margini</div>
    </div>
   
    <div class="simplified-table-container">
      <table class="simplified-table-custom">
        <thead>
          <tr>
            <th class="col-mese">Mese Competenza</th>
            <th class="col-margine text-right">Margine pagato</th>
            <th class="col-margine text-right">Margine atteso</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="3" class="text-center">Nessun dato trovato per il rappresentante e l'anno selezionati.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</template>

<script>
import moment from 'moment'
import RappresentantiService from '@/services/ask-management/rappresentanti-service'
import { ref, onMounted, getCurrentInstance, watch } from 'vue';
import Loader from '@/components/Loader.vue'


export default {
  components: {
    Loader
  },
  props: {
    idRappresentante: {
      type: Number,
      default: null
    },
    rappresentanteName: {
      type: String,
      default: ''
    },
    annoSelezionato: {
      type: Number,
      default: null
    },
    autoSearch: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {

    const loader = ref(false)
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const rappresentantiService = new RappresentantiService(self.$http, self.$eventBus)
    const items = ref([]);
    const hasSearched = ref(false) 

    onMounted(() =>{
      if (props.autoSearch && props.idRappresentante && props.annoSelezionato) {
        hasSearched.value = false 
        
        setTimeout(() => {
          searchData()
        }, 500) 
      }
    })

    watch(() => [props.idRappresentante, props.annoSelezionato], ([newIdRappresentante, newAnnoSelezionato], [oldIdRappresentante, oldAnnoSelezionato]) => {
      if (props.autoSearch && newIdRappresentante && newAnnoSelezionato && 
          (newIdRappresentante !== oldIdRappresentante || newAnnoSelezionato !== oldAnnoSelezionato)) {
        hasSearched.value = false 
        
        setTimeout(() => {
          searchData()
        }, 100)
      }
    }, { immediate: false })

    const searchData = async () => {
      loader.value = true
      rappresentantiService.getSummaryProvvigioniRappresentante(
        props.idRappresentante,
        'monthly',
        'month',
        [props.annoSelezionato]
      )
      .then((res) => {
        items.value = res.items
        hasSearched.value = true 
      }).finally(() => {
        loader.value = false
      })
    }

    const totale_euro = (year) => {
      let total = 0;
      for(let el of items.value[year]) {
        total += el.totale_pcv_pod + el.totale_ricorsivo_pod + el.totale_pcv_pdr + el.totale_ricorsivo_pdr;
      }
      return formatCurrency(total);
    };

    const totale_fatturato_euro = (year) => {
      let total = 0;
      for(let el of items.value[year]) {
        total += el.totale_pcv_pod_fatturato + el.totale_ricorsivo_pod_fatturato + el.totale_pcv_pdr_fatturato + el.totale_ricorsivo_pdr_fatturato;
      }
      return formatCurrency(total);
    };
    
    const formatCurrency = (value) => {
      return value.toLocaleString('it-IT', {style: 'currency', currency: 'EUR'});
    };

    const getMonthFormat = (date) => {
      return moment(new Date(date)).locale('it').format('MMMM YYYY').toUpperCase()
    }

    return { 
      moment,
      items,
      loader, 
      formatCurrency,
      getMonthFormat,
      totale_euro,
      totale_fatturato_euro,
      hasSearched
    }
  }
}
</script>

<style>
.riepilogo-provvigioni .simplified-table-container {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
}

.riepilogo-provvigioni .simplified-table-custom {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.riepilogo-provvigioni .simplified-table-custom th {
  background-color: #f8f9fa;
  border-bottom: 1px solid #e5e7eb;
  padding: 1rem;
  font-weight: 600;
  color: #374151;
  text-align: left;
}

.riepilogo-provvigioni .simplified-table-custom th.text-right {
  text-align: right;
}

.riepilogo-provvigioni .simplified-table-custom td {
  padding: 1rem;
  border-bottom: 1px solid #f3f4f6;
  vertical-align: middle;
}

.riepilogo-provvigioni .simplified-table-custom td.text-right {
  text-align: right;
  font-weight: 500;
}

.riepilogo-provvigioni .simplified-table-custom tfoot td {
  background-color: #f8f9fa;
  border-top: 2px solid #e5e7eb;
  font-weight: 600;
  color: #0a8cf5;
}

.riepilogo-provvigioni .simplified-table-custom tfoot td.text-right {
  text-align: right;
}

.riepilogo-provvigioni .simplified-table-custom tbody tr:hover {
  background-color: #f9fafb;
}

.riepilogo-provvigioni .simplified-table-custom .col-mese {
  width: 40%;
}

.riepilogo-provvigioni .simplified-table-custom .col-margine {
  width: 30%;
}

.riepilogo-provvigioni .simplified-header {
  margin-bottom: 1.5rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e5e7eb;
}

.riepilogo-provvigioni .simplified-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #374151;
  margin-bottom: 0.25rem;
}

.riepilogo-provvigioni .simplified-subtitle {
  font-size: 1.25rem;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 0.25rem;
}

.riepilogo-provvigioni .simplified-entity {
  font-size: 0.875rem;
  color: #9ca3af;
  margin-bottom: 0;
}
</style>

